//import Vue from "vue";
// template plugins
// import $ from 'jquery';
// Vue.prototype.jQuery = jQuery
import JQuery from 'jquery'
window.$ = JQuery